import React from 'react';
import st from './Badge.module.scss';
import { StatusCodeNames } from "../../../../../store/reducers/dashboard/vehicles/statuses/types";
import cn from "classnames";

type BadgeProps = {
	status: StatusCodeNames
	value: string
}

const Badge = (props: BadgeProps) => {
	const {
		status,
		value
	} = props;

	return (
		<div className={cn(st['badge'], st[`badge--${status.toLowerCase()}`])}>
			<span>{value}</span>
		</div>
	)
}

export default Badge;